var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1C9.748 1 1 9.748 1 20.5 1 31.25 9.748 40 20.5 40 31.253 40 40 31.25 40 20.5 40 9.748 31.253 1 20.5 1zm0 40C9.197 41 0 31.805 0 20.5 0 9.196 9.197 0 20.5 0 31.804 0 41 9.196 41 20.5 41 31.805 31.804 41 20.5 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.47 27.955h-3.979v-5.82c0-1.52-.621-2.558-1.99-2.558-1.046 0-1.628.7-1.899 1.378-.103.24-.086.58-.086.915v6.085h-3.941s.052-10.302 0-11.239h3.941v1.762c.233-.77 1.492-1.87 3.502-1.87 2.493 0 4.453 1.616 4.453 5.097v6.25zM13.59 15.311h-.026c-1.269 0-2.093-.861-2.093-1.95 0-1.107.848-1.95 2.144-1.95 1.293 0 2.089.84 2.115 1.948 0 1.089-.822 1.951-2.14 1.951zm-1.666 1.405h3.51v11.239h-3.51V16.716z"
  }))));
};
export default SvgLinkedin;